import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Breadcrumb } from 'react-breadcrumbs'
import { withRouter } from 'react-router-dom'

import { Breadcrumbs } from 'Components/Breadcrumbs'
import { PageTitle } from 'Components/PageTitle'

import { LinkEdit } from 'Components/Link/Edit'
import { ButtonDeleteInline } from 'Components/Buttons/ButtonDeleteInline'
import SettingsIcon from 'Assets/Images/icons/settings'
import SimpleTableTable from '../../../Components/SimpleTableTable'
import CheckMark from 'Assets/Images/icons/checkMark'
import { getCountries } from '../../../Reducers/Countries/actions'
import {
  getLegalDocuments,
  deleteLegalDocumentById,
} from '../../../Reducers/LegalDocument/actions'
import { PATHS } from 'Config/Routing/paths'
import { showReduxModal } from '../../../Reducers/UI/actions'
import { getReadbleDateStringV2 } from '../../../shared/libraries/utils/date'
import SubmitButton from '../../../Components/Form/SubmitButton'
import { formatUserRoleName } from './const'

const styles = {
  header: { padding: '0 50px' },
  tableWrapper: {
    padding: '50px 0',
    backgroundColor: '#fff',
    '& .SearchAndFilters': {
      marginLeft: '50px',
    },
  },
  createButton: { marginLeft: 50, width: 180 },
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  link: { '&:hover': { textDecoration: 'underline' } },
}

const BreadcrumbsLegalDocumentation = ({ currentPath, className }) => {
  return (
    <div className={className}>
      <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
      <Breadcrumb
        data={{
          title: 'Settings',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Legal Documents',
          pathname: currentPath,
        }}
      />
    </div>
  )
}

const LegalDocumentationTable = ({
  classes,
  match,
  history,
  legalDocumentsList,
  countries,
  getCountries,
  getLegalDocuments,
  deleteLegalDocumentById,
  showReduxModal,
}) => {
  useEffect(() => {
    getCountries()
    getLegalDocuments()
  }, [])

  const onDeleteClick = documentId =>
    showReduxModal({
      title: 'Confirmation needed',
      onConfirm: () => deleteLegalDocumentById(documentId),
      children: `You are about delete this document. It will no longer be visible by Brand Ambassadors
        on Sign Up, but still can be viewed on the Platform as a history item.`,
      // confirmLabel: `Ok`,
    })

  const header = [
    'Name',
    'URL',
    'Country',
    'User Role',
    'Active',
    'Uploaded At',
    'Actions',
  ]

  const sortOn = ['Name', 'Country', 'Active', 'Uploaded At']

  const filterOn = ['Name', 'Country', 'Active', 'User Role']

  const searchOn = ['Name', 'URL', 'Country', 'Active']

  const data = useMemo(
    () =>
      legalDocumentsList.map(doc => {
        const country = countries.find(country => country.id === doc.countryId)
        const countryName = country ? country.name : 'Unknown country'

        return {
          id: doc.id,
          'Name': doc.name,
          'URL': doc.url,
          'Active': doc.active ? 'Active' : 'Inactive',
          'Country': doc.countryId ? countryName : 'All countries',
          'Uploaded At': new Date(doc.createdAt).getTime(),
          'User Role': formatUserRoleName[doc.userRole],
        }
      }),
    [legalDocumentsList, countries],
  )

  const postRowRender = document => {
    const editUrl = `${match.url}/edit/${document.id}`
    const uploadedAt = new Date(document['Uploaded At'])

    return {
      ...document,
      'URL': (
        <a className={classes.link} target="_blank" href={document['URL']}>
          {document['URL']}
        </a>
      ),
      'Uploaded At': !isNaN(uploadedAt.getTime())
        ? getReadbleDateStringV2(uploadedAt)
        : '',
      'User Role': document['User Role'],
      'Active': document['Active'] === 'Active' ? <CheckMark /> : '-',
      'Actions': (
        <div className={classes.actionButtons}>
          {document['Active'] === 'Active' && (
            <React.Fragment>
              <LinkEdit to={editUrl} />
              <ButtonDeleteInline
                onClickHandler={() => onDeleteClick(document.id)}
              />
            </React.Fragment>
          )}
        </div>
      ),
    }
  }

  const redirectCreateLegalDocument = () => history.push(`${match.url}/create`)

  return (
    <React.Fragment>
      <BreadcrumbsLegalDocumentation
        currentPath={match.url}
        className={classes.header}
      />
      <PageTitle className={classes.header}>Legal Documents</PageTitle>
      <div className={classes.tableWrapper}>
        <SubmitButton
          className={classes.createButton}
          value="Add legal document"
          onClick={redirectCreateLegalDocument}
          size="medium"
        />
        <SimpleTableTable
          header={header}
          data={data}
          filterOn={filterOn}
          sortOn={sortOn}
          postRowRender={postRowRender}
          searchOn={searchOn}
          showPages={false}
        />
      </div>
    </React.Fragment>
  )
}
LegalDocumentationTable.propTypes = {
  countries: PropTypes.array.isRequired,
  legalDocumentsList: PropTypes.array.isRequired,
  getCountries: PropTypes.func.isRequired,
  getLegalDocuments: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  countries: state.countries.countriesList,
  legalDocumentsList: state.legalDocument.legalDocumentsList,
})

const mapDispatchToProps = {
  getCountries,
  getLegalDocuments,
  deleteLegalDocumentById,
  showReduxModal,
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(LegalDocumentationTable)),
)



// WEBPACK FOOTER //
// ./src/Containers/Settings/LegalDocumentation/LegalDocumentationTable.jsx